export var test_json_data = {
    address: "Near to store Ms Rosa",
    age: "36",
    balanceDue1: 7956,
    balanceDue2: 7956,
    balanceDue3: 7069,
    balanceDue4: 7068,
    balanceDue5: 4951,
    balanceDue6: 4950,
    balanceDueTotal: 39950,
    campus_ABQ: "yes",
    cancellationFee1: "0",
    cancellationFee2: "0",
    cancellationFee3: "0",
    cancellationFee4: "0",
    cancellationFee5: "0",
    cancellationFee6: "0",
    cancellationFeeTotal: 0,
    cashPayment_yes: "yes",
    city: "Cochabamba",
    classAttendanceTime: "9AM_2PM_Monday_Thursday",
    code1: "123123",
    code2: "1231232",
    code3: "123123123",
    code4: "123123",
    code5: "123123",
    code6: "123123",
    date: "January 2020",
    dateOfBirth: "09/01/2020",
    endDate1: "2021-01-31T04:00:00.000Z",
    endDate2: "2021-05-16T04:00:00.000Z",
    endDate3: "2021-09-05T04:00:00.000Z",
    endDate4: "2022-01-09T04:00:00.000Z",
    endDate5: "2022-03-13T04:00:00.000Z",
    endDate6: "2022-05-12T04:00:00.000Z",
    fee1: "0",
    fee2: "0",
    fee3: "0",
    fee4: "0",
    fee5: "427",
    fee6: "426",
    feeTotal: 853,
    financialAid_yes: "yes",
    firstName: "Franklin test",
    homePhone: "123123123123",
    lastName: "Franklin test",
    maidenName: "some mainden",
    maritalStatus: "single",
    nameHighSchool: "CochabambaBolivia12345",
    namePreviousCollege: "Colegio Arquidiosesano Pio XII",
    no: "123",
    other: "Some other 22222",
    other1: "0",
    other2: "0",
    other3: "0",
    other4: "0",
    other5: "0",
    other6: "0",
    otherTotal: 0,
    paymentReceive1: "0",
    paymentReceive2: "0",
    paymentReceive3: "0",
    paymentReceive4: "0",
    paymentReceive5: "0",
    paymentReceive6: "0",
    paymentReceiveTotal: 0,
    placeOfBirth: "Cochabambamanta",
    previousTraining: "Some previous training",
    programCheckbox_associate: "yes",
    programCheckbox_certificate: "no",
    programCost1: 7956,
    programCost2: 7956,
    programCost3: 7069,
    programCost4: 7068,
    programCost5: 4951,
    programCost6: 4950,
    programCostTotal: 39950,
    programGraduationDate: "2022-05-12T04:00:00.000Z",
    programHour: "99",
    programLength: "19.5",
    programOptions: "ATM",
    programType: "Quarter_Credit",
    ssn: "1234556",
    state: "DC",
    supplies1: "614",
    supplies2: "493",
    supplies3: "0",
    supplies4: "0",
    supplies5: "0",
    supplies6: "0",
    suppliesTotal: 1107,
    termBeginning: "10052020",
    textbooks1: "273",
    textbooks2: "394",
    textbooks3: "0",
    textbooks4: "0",
    textbooks5: "0",
    textbooks6: "0",
    textbooksTotal: 667,
    transferCreditPending_yes: "yes",
    tuition1: "7069",
    tuition2: "7069",
    tuition3: "7069",
    tuition4: "7068",
    tuition5: "4524",
    tuition6: "4524",
    tuitionTotal: 37323,
    type: "Some typooooo",
    veteranBenefit_yes: "yes",
    veteranStudent_yes: "yes",
    volume: "IX11",
    workPhone: "59175930626",
    yearGraduated: "2012",
    zipCode: "0000",
    financial__tuition: "435"
};
//# sourceMappingURL=data:application/json;base64,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